import { take, filter, map } from 'rxjs/operators';
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable, Subscription } from 'rxjs';

import { Store } from '@ngrx/store';

import { NotificationService } from 'src/core';

import {
  AppState,
  BLOTTER_CANCELREPLACE,
  BLOTTER_ISSUE,
  CURRENT_SYMBOL,
} from 'src/app';
import { SelectTab } from 'src/app/state/actions/operation-puppet.actions';
import { SelectedPuppetTab } from '@models/puppet.class';

@Component({
  selector: 'hb-cancel-replace',
  templateUrl: 'cancelAndReplaceConfirmation.component.html',
  styleUrls: ['./cancelAndReplaceConfirmation.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CancelAndReplaceConfirmationComponent {
  private elPatronDataSubscription: Subscription;
  private elPatronData: any;
  private readToken: string;
  private userLoggedInSubscription: Subscription;
  public saleType: any;
  public mfaType: any;
  public token: any;
  public isValidToken: any;

  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private dialogRef: MatDialogRef<CancelAndReplaceConfirmationComponent>,
    private store: Store<AppState>,
    private notificationService: NotificationService,

    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.scanForElPatronData();
    this.scanForUser();

    iconRegistry.addSvgIcon(
      'close',
      sanitizer.bypassSecurityTrustResourceUrl('images/icons/cancel.svg'),
    );
  }

  close(value: any, isReplace: boolean): void {
    if (isReplace) {
      const replaceTitles =
        this.data.order.originalQuantity -
        this.data.order.assignedQuantity -
        this.data.order.cancelQuantity;
      this.store.dispatch({
        type: BLOTTER_CANCELREPLACE,
        payload: {
          isCancelReplace: true,
          orderPrice: this.data.order.price,
          orderTypeId: this.data.order.orderTradeTypeId,
          orderReplaceTitles: replaceTitles,
        },
      });
      this.store.dispatch({
        type: CURRENT_SYMBOL,
        payload: {
          issueID: this.data.issue.issueID,
        },
      });
      this.store.dispatch(new SelectTab(SelectedPuppetTab.TRADE));
    }

    this.dialogRef.close(value);
  }

  scanForElPatronData() {
    this.elPatronDataSubscription = this.store
      .select('elPatronData')
      .pipe(
        map((value: any) => value.toJS()),
        filter((value: any) => value.URL_SETTINGS !== undefined),
        take(1),
      )
      .subscribe((value: any) => {
        this.elPatronData = value;
      });
  }

  scanForUser() {
    this.userLoggedInSubscription = this.store
      .select('loggedInUser')
      .pipe(
        map((value: any) => value.toJS()),
        map((value: any) => {
          return {
            isReadAndWrite: value.isReadAndWrite,
            readToken: value.sessionToken,
          };
        }),
      )
      .subscribe((userInfo: any) => {
        this.readToken = userInfo.readToken;
      });
  }

  sendOperativeMessage(titleText: string, messageText: string) {
    let notificationMessage: any = {};

    notificationMessage = {
      message: messageText || 'Necesitas ingresar el token',
      title: titleText || 'Token Necesario',
    };
    this.notificationService.showWarning(notificationMessage);
  }

  public changeToken() {}
}
